// @ts-nocheck
/* eslint-disable */
/**
 * @class Vrstva, která bere data z lookupu a dle pravidel je rozhazuje - uprave dle potreb mapy.cz
 * @private
 */
Mapy.Lookup = function(id) {
	SMap.Layer.Lookup.call(this, id);
};

Mapy.Lookup.prototype = Object.create(Object.assign({}, SMap.Layer.prototype, SMap.Layer.Multi.prototype, SMap.Layer.Lookup.prototype));

/**
 * Lookup marker obj. Misto api POI pouzijeme svuj.
 * @type {Object}
 */
Mapy.Lookup.LOOKUP_MARKER = {
	"foto": SMap.Marker.FotoPOI,
	"ffoto": SMap.Marker.FotoPOI
};

Mapy.Lookup.prototype.removeAll = function() {
	for (var i=0;i<this._layers.length;i++) {
		this._layers[i].removeAll("poi");
	}
}

Mapy.Lookup.prototype.redraw = function() {
	for (var i = 0; i < this._layers.length; i++) {
		this._layers[i].redraw(false);
	}
}
